import { render, staticRenderFns } from "./roleJurisdiction.vue?vue&type=template&id=7cd1fc4d&scoped=true"
import script from "./roleJurisdiction.vue?vue&type=script&lang=js"
export * from "./roleJurisdiction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd1fc4d",
  null
  
)

export default component.exports